import { Popup } from './popup';

const helpMob = new Popup('#jsHelpWrap', '#jsOpenMobHelp', '#jsCloseHelp');
helpMob.init();

const mobMenu = new Popup('#jsMenuWrap', '#jsOpenMenu', '#jsCloseMenu');
mobMenu.init();

const user = new Popup('#jsUserWrap', '#jsOpenUser', '#jsCloseUser');
user.init();

const cart = new Popup('#jsCartWrap', '#jsOpenCart', '#jsCloseCart');
cart.init();

const finderMob = new Popup(
  '#jsFinderWrap',
  '#jsOpenMobFinder',
  '#jsCloseFinder',
);
finderMob.init();

const finderDesk = new Popup(
  '#jsFinderWrap',
  '#jsOpenDeskFinder',
  '#jsCloseFinder',
);
finderDesk.init();

const filter = new Popup(
  '#jsFilterWrap',
  '#jsOpenFilter',
  '#jsCloseFilter',
);
filter.init();
